export default __webpack_public_path__ + "static/media/arrow.d3c9db86.svg";